/** 電話番号（半角数字）にマッチする */
// より厳密に定義するか検討
export const phoneNumberRegExp = /^[0-9]+$/

/** ひらがなにマッチする */
export const hiraganaRegExp = /^[\u3041-\u3093]+$/u

/** 半角英数字、記号にマッチする */
export const alphanumericsAndSpecialCharsRegExp = /^[a-zA-Z0-9!-/ :-@¥[-`{-~]*$/
